__turbopack_context__.v({
  "actionButton": "G4PvAG_actionButton",
  "disabledOption": "G4PvAG_disabledOption",
  "disabledOptionContent": "G4PvAG_disabledOptionContent",
  "disabledOptionIcon": "G4PvAG_disabledOptionIcon",
  "disabledOptionTooltip": "G4PvAG_disabledOptionTooltip",
  "headerActions": "G4PvAG_headerActions",
  "locationButton": "G4PvAG_locationButton",
  "locationButtonCreationMode": "G4PvAG_locationButtonCreationMode",
  "locationButtonError": "G4PvAG_locationButtonError",
  "locationContainer": "G4PvAG_locationContainer",
  "option": "G4PvAG_option",
  "optionsWrapper": "G4PvAG_optionsWrapper",
  "popoutContainer": "G4PvAG_popoutContainer",
  "popoutHeader": "G4PvAG_popoutHeader",
  "popoutLocationContainer": "G4PvAG_popoutLocationContainer",
  "searchContainer": "G4PvAG_searchContainer",
  "searchIcon": "G4PvAG_searchIcon",
  "searchIconButton": "G4PvAG_searchIconButton",
  "searchInput": "G4PvAG_searchInput",
  "taskCellPopout": "G4PvAG_taskCellPopout",
  "taskCellPopoutButton": "G4PvAG_taskCellPopoutButton",
  "taskCellPopoutButtonLabel": "G4PvAG_taskCellPopoutButtonLabel",
});
